var map = {
	"./12x12-laptop.svg": "3ca5",
	"./12x12-user-purple.svg": "82d7",
	"./12x12-user.svg": "8ed3",
	"./16x16-add-notes-grey.svg": "4696",
	"./16x16-add-notes.svg": "9c99",
	"./16x16-arrow-left.svg": "d531",
	"./16x16-arrow-right.svg": "8a51",
	"./16x16-arrow-up.svg": "1a87",
	"./16x16-blue-information.svg": "7784",
	"./16x16-blue-time.svg": "7a11",
	"./16x16-box-chart.svg": "87bf",
	"./16x16-box-edit.svg": "2c26",
	"./16x16-box.svg": "09f9",
	"./16x16-calculator.svg": "2529",
	"./16x16-calendar.svg": "1ae4",
	"./16x16-cancel-round-bordered.svg": "ad12",
	"./16x16-cancel-round.svg": "d294",
	"./16x16-card-tick.svg": "5503",
	"./16x16-check-round.svg": "221b",
	"./16x16-chevron-down.svg": "c883",
	"./16x16-chevron-left.svg": "957d",
	"./16x16-chevron-right.svg": "de87",
	"./16x16-chevron-up.svg": "cfbf",
	"./16x16-close.svg": "91fa",
	"./16x16-customer.svg": "d7b6",
	"./16x16-directbox-receive.svg": "8385",
	"./16x16-directup-green.svg": "0e90",
	"./16x16-document-text.svg": "d897",
	"./16x16-document.svg": "693d",
	"./16x16-download-black.svg": "f3d1",
	"./16x16-download-disable.svg": "b46f",
	"./16x16-download-green.svg": "3f9a",
	"./16x16-download.svg": "375f",
	"./16x16-edit-white.svg": "b3ad",
	"./16x16-edit.svg": "eb5c",
	"./16x16-eye.svg": "7c5c",
	"./16x16-filter-add.svg": "1def",
	"./16x16-global.svg": "a75a",
	"./16x16-info-circle.svg": "f6b2",
	"./16x16-info-triangle.svg": "2d25",
	"./16x16-invoice.svg": "21e2",
	"./16x16-koinworks-round.svg": "5472",
	"./16x16-laptop.svg": "c9a0",
	"./16x16-lock-green.svg": "e88b",
	"./16x16-lock.svg": "95cc",
	"./16x16-mail-red.svg": "1207",
	"./16x16-mail-white.svg": "24f4",
	"./16x16-merge.svg": "c7680",
	"./16x16-messages.svg": "4bd2",
	"./16x16-money-send.svg": "99a9",
	"./16x16-moneys.svg": "1f39",
	"./16x16-pin.svg": "6d39",
	"./16x16-plus copy.svg": "725f",
	"./16x16-plus-green.svg": "0b62",
	"./16x16-plus.svg": "c51a",
	"./16x16-profile.svg": "09fe",
	"./16x16-question-circle.svg": "cacf",
	"./16x16-refresh-alt.svg": "c768",
	"./16x16-revert-green.svg": "f38b",
	"./16x16-save.svg": "b84f",
	"./16x16-search.svg": "4a6e",
	"./16x16-send-message.svg": "64a4",
	"./16x16-tick-circle-blue.svg": "2099",
	"./16x16-tick.svg": "23c4",
	"./16x16-trash.svg": "c761",
	"./16x16-trend-up.svg": "30ad",
	"./16x16-upgrade-arrow.svg": "0e61",
	"./16x16-upload-green.svg": "96a9",
	"./16x16-upload-grey.svg": "7d04",
	"./16x16-upload-white.svg": "b13d",
	"./16x16-upload.svg": "ede9",
	"./16x16-user-black.svg": "4ebe",
	"./16x16-users.svg": "be3a",
	"./16x16-whatsapp.svg": "ecca",
	"./16x16-yellow-alert.svg": "6c79",
	"./20x20-chat.svg": "1ca3",
	"./20x20-delivery.svg": "c816",
	"./20x20-document.svg": "1ba4",
	"./20x20-envelope.svg": "47bb",
	"./20x20-money.svg": "4b5e",
	"./20x20-receipt.svg": "697c",
	"./20x20-wallet.svg": "87fa",
	"./24x24-tunai-circle.png": "a803",
	"./24x24-upload.svg": "76fc",
	"./40x40-approved.svg": "69f0",
	"./40x40-camera-circle.svg": "00fe",
	"./40x40-clipboard.svg": "5d95",
	"./40x40-empty-state.svg": "738e",
	"./40x40-hand-shake.svg": "c7d2",
	"./40x40-money-circle.svg": "90ff",
	"./40x40-paper-doc.svg": "ec6d",
	"./40x40-paper.svg": "56ba",
	"./40x40-receipt-circle.svg": "9eba",
	"./40x40-rejected.svg": "8eb1",
	"./40x40-truck-circle.svg": "13a5",
	"./40x40-upload.svg": "c739",
	"./40x40-waiting.svg": "3340",
	"./48x48-alert-negative.svg": "0404",
	"./48x48-alert-positive.svg": "f4cc",
	"./48x48-alert-warning.svg": "924c",
	"./48x48-icon-add.svg": "ab3a",
	"./48x48-icon-repeat.svg": "4427",
	"./80x80-messages.svg": "bd65",
	"./Icon-stroke-download-primary.svg": "a355",
	"./Icon-stroke-download.svg": "5bf5",
	"./Icon-stroke.svg": "184a",
	"./add-new-image.svg": "1d66",
	"./alert.svg": "1540",
	"./arrow-circle-left.svg": "c000",
	"./arrow-circle-right.svg": "cf79",
	"./arrow-down.svg": "1f5d",
	"./arrow-up.svg": "a4f5",
	"./box.svg": "1e69",
	"./briefcase.svg": "df9f",
	"./calendar-2.svg": "a236",
	"./calendar-white.svg": "fe79",
	"./calendar.svg": "6bca",
	"./call.svg": "129c",
	"./cancel-red.svg": "5c5d",
	"./card.svg": "f7ec",
	"./category-alat-berat.svg": "3f3d",
	"./category-arsitektural.svg": "ba29",
	"./category-mep.svg": "1258",
	"./category-struktural.svg": "8c1b",
	"./check-circle-md.svg": "89b0",
	"./check-circle-red.svg": "1dd8",
	"./check-green-xxl.svg": "51e9",
	"./check-stepper-active.svg": "d52d",
	"./close-circle.svg": "9d2f",
	"./completed.svg": "8bd5",
	"./dashboard/box.svg": "4185",
	"./dashboard/empty-wallet.svg": "507c",
	"./dashboard/house-2.svg": "8846",
	"./dashboard/icons_1.svg": "09a5",
	"./dashboard/icons_10.svg": "c7b6",
	"./dashboard/icons_2.svg": "f5d9",
	"./dashboard/icons_3.svg": "2088",
	"./dashboard/icons_4.svg": "d26a",
	"./dashboard/icons_5.svg": "9cac",
	"./dashboard/icons_6.svg": "a804",
	"./dashboard/icons_7.svg": "380b",
	"./dashboard/icons_8.svg": "ec2e",
	"./dashboard/icons_9.svg": "d571",
	"./dashboard/money-send.svg": "f0fb",
	"./dashboard/receipt-text.svg": "2f41",
	"./dashboard/shopping-cart.svg": "d5e4",
	"./dashboard/tag.svg": "7d01",
	"./dashboard/vuesax-1.svg": "6aa4",
	"./dashboard/vuesax.svg": "996e",
	"./delete.svg": "a91f",
	"./doc-board.svg": "0e1d",
	"./document-text.svg": "d146",
	"./download-underscore.svg": "77b7",
	"./download.svg": "0339",
	"./edit.svg": "c560",
	"./export.svg": "fd49",
	"./eye-close.svg": "baee",
	"./eye-open.svg": "1820",
	"./filter-add.svg": "fa9a",
	"./gallery.svg": "cb81",
	"./graph.svg": "2000",
	"./home-illust.svg": "eca2",
	"./ic-ecommerce-house.svg": "1a65",
	"./ims.svg": "08c8",
	"./input-spinner-dec.svg": "5b9b",
	"./input-spinner-inc.svg": "8171",
	"./location-add-white.svg": "e6be",
	"./location-add.svg": "2714",
	"./location-duocolor.svg": "1e80",
	"./location.svg": "c411",
	"./location1.svg": "f3b9",
	"./logout.svg": "c5d0",
	"./mail-box.svg": "6a8f",
	"./message-question.svg": "257a",
	"./minus-small.svg": "c992",
	"./money-icon.svg": "9e37",
	"./money-recive.svg": "5b8b",
	"./money-remove.svg": "3b2c",
	"./money-send.svg": "026f",
	"./money-tick.svg": "8bee",
	"./money-time.svg": "8f23",
	"./navIcon.svg": "602c",
	"./note-outline.svg": "eadd",
	"./noteadd.svg": "1422",
	"./paper-link-inv.svg": "1a21",
	"./paper-logo.png": "fb94",
	"./people.svg": "f2de",
	"./personalcard.svg": "9f60",
	"./pin-juragan.svg": "1066",
	"./pin.svg": "3eef",
	"./play-outline.svg": "7ad8",
	"./plus-circle.svg": "6781",
	"./plus-vector.svg": "6e16",
	"./profile-2user.svg": "e302",
	"./profile-circle.svg": "4c3c",
	"./qr-code-inv.svg": "b406",
	"./qr-code-white.svg": "4da0",
	"./qr-code.svg": "a8a4",
	"./receipt-2.svg": "00fe9",
	"./receipt.svg": "fe85",
	"./refresh-white.svg": "210c",
	"./remove-circle-red.svg": "9306",
	"./remove-red-xxl.svg": "d6d1",
	"./repeat.svg": "7b29",
	"./send-2.svg": "224c",
	"./send-3.svg": "3acb",
	"./send-email-circle.svg": "48ff",
	"./send-email.svg": "bdf9",
	"./setting-2.svg": "d7cd",
	"./shopping-cart.svg": "3ab1",
	"./sms.svg": "f35f",
	"./so/tunai-icon.svg": "abb9",
	"./star-blue.svg": "19a0",
	"./star.svg": "0a83",
	"./tick-circle-green.svg": "60dc",
	"./tick-circle.svg": "8b2c",
	"./ticket.svg": "b9f2",
	"./time.svg": "e86f",
	"./timer.svg": "d912",
	"./trend-up.svg": "4871",
	"./upload-cloud.svg": "a073",
	"./view-notes.svg": "416e",
	"./warning-16x16.svg": "5795",
	"./x-circle.svg": "89b0e",
	"./x-red.svg": "16dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";